import React from "react"
import { Modal } from "@shopify/polaris"
import RadioButton from "components/widgets/CollectPage/forms/fields/RadioButton"
import { useTranslation } from "react-i18next"
import { useModuleContext } from "components/widgets/CollectPage/forms/Module"
import { RETURN_OBJECTS } from "services/translations/config"
import { useAppContext } from "components/AppContext"
import ModalInventoryChoiceTemplate from "views/molecules/collects/ModalInventoryChoiceTemplate"
import useConfirmCollectionChange from "components/widgets/CollectPage/forms/useConfirmCollectionChange"

export const MANUAL_CHOICE = "manual"
export const INVENTORY_CHOICE = "inventory"

const ModalAiServiceChoice = () => {
  const { moduleIsActive } = useModuleContext()
  const { envCollect } = useAppContext()
  const { onChange, confirmationModal } = useConfirmCollectionChange(
    "ai_service_source",
    envCollect?.has_ai_services
  )

  const { t } = useTranslation()
  const translationKey = t(
    "collect:questions.13.ai_services.ai_services_inventory_file.modal",
    RETURN_OBJECTS
  )

  const defaultTranslation = {
    title: t("collect:inventory_choice.title"),
    choices: {
      manual: t("collect:inventory_choice.manual"),
      inventory: t("collect:inventory_choice.inventory"),
    },
  }

  const translation =
    translationKey && typeof translationKey === "object"
      ? {
          title: translationKey.title || defaultTranslation.title,
          choices: {
            manual:
              translationKey.choices?.manual ||
              defaultTranslation.choices.manual,
            inventory:
              translationKey.choices?.inventory ||
              defaultTranslation.choices.inventory,
          },
        }
      : defaultTranslation

  return (
    <ModalInventoryChoiceTemplate
      title={translation.title}
      showUpdateWarning={envCollect?.has_ai_services}
    >
      <Modal.Section>
        <RadioButton
          id="ai_service_source"
          choices={[
            {
              label: translation.choices.manual,
              value: MANUAL_CHOICE,
            },
            {
              label: translation.choices.inventory,
              value: INVENTORY_CHOICE,
            },
          ]}
          disabled={!moduleIsActive}
          onChange={onChange}
        />
      </Modal.Section>
      {confirmationModal}
    </ModalInventoryChoiceTemplate>
  )
}

export default ModalAiServiceChoice
